import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { FeatureConfigResponseDto } from '../../commonTypes/organization.types';

export interface FeatureConfigState {
    items: FeatureConfigResponseDto[];
    isReady: boolean;
}

const initialState: FeatureConfigState = {
    items: [],
    isReady: false,
};

export const featureConfigSlice = createSlice({
    name: 'featureConfig',
    initialState,
    reducers: {
        setFeatureConfig: (state, action: PayloadAction<FeatureConfigResponseDto[]>) => {
            state.items = action.payload;
            state.isReady = true;
        },
        resetFeatureConfig: () => initialState,
    },
});

export const selectFeatureConfig = (state: RootState) => state.featureConfig.items;
export const selectFeatureConfigReady = (state: RootState) => state.featureConfig.isReady;

export const { setFeatureConfig, resetFeatureConfig } = featureConfigSlice.actions;
export default featureConfigSlice.reducer;
